export const LANGUAGES = {
  UK: 'uk',
  RU: 'ru',
  EN: 'en',
};

export const UI_LANGUAGES = [
  { name: LANGUAGES.UK, titleKey: 'languages.uk' },
  { name: LANGUAGES.RU, titleKey: 'languages.ru' },
  { name: LANGUAGES.EN, titleKey: 'languages.en' },
];

export const UI_LANGUAGE_STORAGE_KEY = 'ui-language';

export const INIT_UI_LANGUAGE = LANGUAGES.EN; // cookies.get(UI_LANGUAGE_STORAGE_KEY) || LANGUAGES.UK;
